// extracted by mini-css-extract-plugin
export default {"logo":"components-Shared-Logo-themes-BGH-styles__logo--AEN1z"};